import React from 'react';
import { UserShape, SubscriptionShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Waiting from '../components/waiting';

export default class CancelSubscription extends React.Component {

  static propTypes = {
    user: UserShape,
    subscription: SubscriptionShape,
    onCancelSubscription: PropTypes.func
  }

  state = {
    isProcessing: false
  }

  render() {
    if (this.props.subscription.get('active')) {
      return this.renderCancelPlease();
    } else if (this.props.subscription.get('loading')) {
      return this.renderCanceling();
    } else {
      return this.renderCanceled();
    }
  }

  renderCancelPlease() {
    return (
      <div className='subscription'>
        <h2>Cancel Unlimited Plan?</h2>
        <p>
          You're paying ${process.env.REACT_APP_SUBSCRIPTION_FEE} <b>per month</b> for unlimited tacks.
          Unlimited tacks help you remember more words at once. Who doesn't want to remember more words?
        </p>
        <p>
          If you cancel, you'll be on the <b>Free for One</b> plan, and we'll help you remember one word at a time for free.
        </p>
        <p>
          Questions? Email us at hello@yaktack.com.
        </p>
        <div className='action'>
          {this.state.isProcessing ? (
            <button className='btn btn-dark' disabled>Nevermind</button>
          ) : (
              <Link to='/account' className='btn btn-dark'>Nevermind</Link>
          )}
          <button
            className='btn btn-outline-secondary'
            data-primary-cta='true'
            onClick={() => this.onCancelSubscription()}
            disabled={this.state.isProcessing}
          >
            {this.state.isProcessing ? 'Canceling...' : 'Yes, Cancel'}
          </button>
        </div>
      </div>
    );
  }

  renderCanceling() {
    return(<Waiting waitingText='Canceling' />);
  }

  renderCanceled() {
    return (
      <div className='row confirmation'>
        <div className='col-sm-12'>
          Ok. Your subscription is cancelled.
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/account' className='btn btn-dark' data-primary-cta='true'>Ok</Link>
        </div>
      </div>
    );
  }

  onCancelSubscription() {
    this.setState({ isProcessing: true });
    this.props.onCancelSubscription(this.props.user.get('email'));
  }
}



// WEBPACK FOOTER //
// ./src/components/cancel_subscription.jsx